"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _settingsInteractions = require("../actions/settingsInteractions");

var _params = require("hub-http/helpers/params");

var initialState = new _immutable.Map({
  selectedStoreToken: (0, _params.parse)(window.location.search.substring(1)).storeToken
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _settingsInteractions.SettingsInteractionsActionTypes.SELECT_STORE, function (state, action) {
  return state.set('selectedStoreToken', action.payload);
}), initialState);

exports.default = _default;
module.exports = exports.default;